import { useQuery } from '@apollo/client';
import { PageModal } from '@otp/ui';
import {
  WttpQuestionnaireDocument,
  WttpQuestionnaireResponseDocument,
  WttpQuestionnaireResponseQuery,
} from 'src/graphql/generated/graphql';
import WttpQuestionnaireResponseQuestionsList from './questions-list';

type WttpQuestionnaireResponseModalProps = {
  questionnaireResponseId: string;
  onClose: () => void;
};

export const WttpQuestionnaireResponseModal = ({
  questionnaireResponseId,
  onClose,
}: WttpQuestionnaireResponseModalProps) => {
  const { data: questionnaireResponseData } =
    useQuery<WttpQuestionnaireResponseQuery>(
      WttpQuestionnaireResponseDocument,
      {
        variables: { id: questionnaireResponseId },
        fetchPolicy: 'cache-and-network',
      },
    );

  const questionnaireResponse =
    questionnaireResponseData?.wttpQuestionnaireResponseById;
  const responses = questionnaireResponse?.responses || [];

  const { data: questionnaireData } = useQuery(WttpQuestionnaireDocument, {
    skip: !questionnaireResponse,
    variables: {
      id: questionnaireResponse?.questionnaireId || '',
    },
    fetchPolicy: 'cache-and-network',
  });

  const questionnaire = questionnaireData?.wttpQuestionnaireById;
  const questions = questionnaire?.questions || [];
  const title = questionnaire?.name || '';

  return (
    <PageModal open title={title} onClose={onClose}>
      {!questionnaire && <div>Loading...</div>}
      {questionnaireResponse && (
        <WttpQuestionnaireResponseQuestionsList
          questionnaireResponse={questionnaireResponse}
          questions={questions}
          responses={responses}
          onClose={onClose}
        />
      )}
    </PageModal>
  );
};
